import { useEffect, useState } from 'react'
import axios from 'axios'
import { getPublicacionCartaDigitalBySlug } from '@utils/api/api.publicaciones-cartas-digitales'
import type { CartaDigitalPublica } from '@models/carta-digital-publica'

export type CartaDigitalPublicaStatus = 'loading' | 'found' | 'not_found' | 'disabled' | 'error'

export type CartaDigitalPublicaState = {
    status: CartaDigitalPublicaStatus
    data: CartaDigitalPublica | null
}

const initialState: CartaDigitalPublicaState = {
    status: 'loading',
    data: null,
}

export const useCartaDigitalPublica = (slug?: string) => {
    const [state, setState] = useState<CartaDigitalPublicaState>(initialState)

    useEffect(() => {
        if (!slug) {
            setState({ status: 'not_found', data: null })
            return undefined
        }

        let cancelled = false

        const fetchCarta = async () => {
            setState({ status: 'loading', data: null })

            try {
                const response = await getPublicacionCartaDigitalBySlug({ slug })

                if (cancelled) return

                if (!response.data) {
                    setState({ status: 'not_found', data: null })
                    return
                }

                if (!response.data.habilitado) {
                    setState({ status: 'disabled', data: response.data })
                    return
                }

                setState({ status: 'found', data: response.data })
            } catch (error) {
                if (cancelled) return

                if (axios.isAxiosError(error) && error.response?.status === 404) {
                    setState({ status: 'not_found', data: null })
                    return
                }

                setState({ status: 'error', data: null })
            }
        }

        fetchCarta()

        return () => {
            cancelled = true
        }
    }, [slug])

    return state
}
